export default __webpack_public_path__ + "svg/banner/experts.svg?0a74bc82";